/**
 * Build the URL Supabase should land the user on after they tap the
 * "Verify Email" link in their signup confirmation email. Returns the
 * user's current full URL (origin + path + search + hash) with a
 * `verified=1` flag appended so the page can detect the confirmation,
 * preserving any existing referral / utm params the user signed up from.
 *
 * Falls back to `${origin}/account?verified=1` when called outside the
 * browser or when window.location is unavailable.
 */
export function buildSignupRedirectUrl(): string {
  try {
    if (typeof window === "undefined" || !window.location) return "/account?verified=1";
    const loc = window.location;
    const params = new URLSearchParams(loc.search);
    params.set("verified", "1");
    return `${loc.origin}${loc.pathname}?${params.toString()}${loc.hash || ""}`;
  } catch {
    return `${typeof window !== "undefined" ? window.location.origin : ""}/account?verified=1`;
  }
}
